/**
 * La marque d'une réponse proposée, une fois la question du quiz relue — la règle de l'ancien
 * `PrerequisiteQuizDisplay`, en deux couleurs comme le « Défi éclair » :
 *  - la bonne réponse : `right` (qu'elle ait été choisie ou non) ;
 *  - celle que l'élève a choisie à tort : `wrong` ;
 *  - les autres : `none`.
 * Sans bonne réponse servie, la réponse de l'élève jugée juste par le serveur reste `right`.
 */
import { type UIQuizReviewOptionMark, type UIQuizReviewResult } from "../types/studentQuizReview"

export function quizOptionMark(
    option: string,
    question: { answer: string | null; correctAnswer: string | null; result: UIQuizReviewResult }
): UIQuizReviewOptionMark {
    if (question.correctAnswer != null && option === question.correctAnswer) return "right"
    if (question.answer != null && option === question.answer) return question.result === "right" ? "right" : "wrong"
    return "none"
}
